export default {
  root: {
    color: '#E4E6EB !important',
    fontFamily: 'archia-medium !important'
  },
  gutterBottom: {
    marginBottom: 8
  },
};
